// extracted by mini-css-extract-plugin
export default {"routesContainer":"profile_sidebar_routesContainer__Jc9+5","routes":"profile_sidebar_routes__qilW4","logoutBtn":"profile_sidebar_logoutBtn__YycRq"};